<template>
  <div class="content">
    <NavBar />
    <v-main>
      <v-container fluid>
        <div class="content-main">
          <v-card class="profile bg-white" title="Perfil">
            <v-card-text>
              <ProfileModule />
            </v-card-text>
          </v-card>
          <v-card class="main pa-5" title="Inicio">
            <v-tabs v-model="tab" align-tabs="end" color="primary">
              <v-tab :value="1">Convocatorias</v-tab>
              <v-tab :value="2">Eventos</v-tab>
            </v-tabs>
            <v-tabs-window v-model="tab">
              <v-tabs-window-item :key="1" :value="1">
                <div class="ma-5">
                  <div>
                    <v-img class="mx-auto" src="@/assets/images/web-empty.png" width="550"/>
                  </div>
                  <div class="text-center">
                    Próximamente podrás encontrar en este espacio las convocatorias disponibles para que puedar participar de ellas. 
                  </div>
                </div>
              </v-tabs-window-item>
              <v-tabs-window-item :key="2" :value="2">
                <div class="ma-5">
                  <div>
                    <v-img class="mx-auto" src="@/assets/images/web-empty.png" width="550"/>
                  </div>
                  <div class="text-center">
                    En este momento no existen eventos disponibles.
                  </div>
                </div>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card>
          <v-card class="skills" title="Mis Competencias">
            <v-card-text>
              <SkillModuleVue />
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </v-main>
  </div>
</template>
<script setup>
  import { ref } from 'vue';
  import NavBar from '../components/navbar/NavBar'
  import ProfileModule from '../components/profile/ProfileModule'
  import SkillModuleVue from '@/components/profile/SkillModule.vue';
    
  const tab = ref(1)
</script>